var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.damageLocatorComponentName, {
    tag: "component",
    attrs: {
      "damage-locations": _vm.damageLocations,
      "clickedColor": _vm.clickedColor,
      "clickable": _vm.clickable,
      "readOnly": _vm.readOnly
    },
    on: {
      "svgClicked": function svgClicked($event) {
        return _vm.$emit('svgClicked', $event);
      },
      "update:damageLocations": function updateDamageLocations($event) {
        _vm.damageLocations = $event;
      },
      "update:damage-locations": function updateDamageLocations($event) {
        _vm.damageLocations = $event;
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }